import { Box, styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: linear-gradient(
            to bottom left,
            ${props => props.theme.palette.primary.main},
            black,
            black
        );
        padding: 20px 0px;
        ${props => props.theme.breakpoints.down("sm")} {
            padding: 20px 0px;
        }
    `,
    Content: styled(Box)`
        margin: 20px 0px;
        width: 500px;
        height: 600px;
        box-shadow: 0px 0px 5px 0.5px ${props => props.theme.palette.primary.light};
        border-radius: 8px;
        background-color: ${props => props.theme.palette.secondary.dark};
        display: flex;
        flex-direction: column;
        padding: 10px;

        ${props => props.theme.breakpoints.down("sm")} {
            width: 350px;
            margin: 10px 0px;
        }
        ${props => props.theme.breakpoints.down("xs")} {
            width: 300px;
        }
    `,
};
